// extracted by mini-css-extract-plugin
var _1 = "TableModalInitialError-moduleTableModalInitialError___rAJT";
var _2 = "TableModalInitialError-modulebutton__lK2ol";
var _3 = "TableModalInitialError-moduletext__BeYt4";
export { _1 as "TableModalInitialError", _2 as "button", _3 as "text" }
